// Azzurro vocabulary expansion — FAMILY theme (net-new cards).
//
// Extends the `family` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `spanish`, so every value is unique.
//   [ italian, english, emoji, part_of_speech, gender, example_it, example_en ]

export const VOCAB_FAMILY = [
  {
    theme: "family", tier: "A1", rows: [
      ["i genitori", "parents", "👪", "noun", "m", "I miei genitori vivono a Oslo.", "My parents live in Oslo."],
      ["i figli", "children", "👧", "noun", "m", "Hanno tre figli.", "They have three children."],
      ["il marito", "husband", "🤵", "noun", "m", "Suo marito cucina molto bene.", "Her husband cooks very well."],
      ["il compagno", "partner / couple", "💑", "noun", "m", "Vive con il suo compagno.", "She lives with her partner."],
      ["il fidanzato", "boyfriend", "❤️", "noun", "m", "Il mio fidanzato è di Napoli.", "My boyfriend is from Naples."],
      ["la fidanzata", "girlfriend", "💕", "noun", "f", "La sua fidanzata parla francese.", "His girlfriend speaks French."],
      ["il gemello", "twin", "👬", "noun", "m", "Il suo gemello vive a Roma.", "His twin lives in Rome."],
      ["sposarsi", "to get married", "💒", "verb", "", "Si sposano a giugno.", "They're getting married in June."],
      ["il matrimonio", "wedding", "💍", "noun", "m", "Il matrimonio è a settembre.", "The wedding is in September."],
      ["il figlio unico", "only child", "🧒", "phrase", "", "Sono figlio unico.", "I'm an only child."],
    ],
  },
  {
    theme: "family", tier: "A2", rows: [
      ["la nipote", "niece", "👧", "noun", "f", "Mia nipote compie dieci anni.", "My niece turns ten."],
      ["la nipotina", "granddaughter", "👧", "noun", "f", "Sua nipotina è nata a marzo.", "His granddaughter was born in March."],
      ["la cugina", "cousin (f)", "👩", "noun", "f", "Mia cugina vive in Cile.", "My cousin lives in Chile."],
      ["la suocera", "mother-in-law", "👵", "noun", "f", "Mia suocera è molto gentile.", "My mother-in-law is very kind."],
      ["la cognata", "sister-in-law", "👩", "noun", "f", "Sua cognata è infermiera.", "His sister-in-law is a nurse."],
      ["la nuora", "daughter-in-law", "👰", "noun", "f", "Sua nuora lavora in banca.", "Her daughter-in-law works at the bank."],
      ["il padrino", "godfather", "🎩", "noun", "m", "Il mio padrino vive vicino.", "My godfather lives nearby."],
      ["divorziato", "divorced", "💔", "adjective", "", "I miei genitori sono divorziati.", "My parents are divorced."],
      ["il patrigno", "stepfather", "👨", "noun", "m", "Il suo patrigno è molto paziente.", "Her stepfather is very patient."],
      ["la matrigna", "stepmother", "👩", "noun", "f", "La mia matrigna cucina benissimo.", "My stepmother cooks brilliantly."],
    ],
  },
  {
    theme: "family", tier: "B1", rows: [
      ["il focolare", "home / household", "🏡", "noun", "m", "Mi manca il mio focolare.", "I miss my home."],
      ["il vincolo", "tie / bond", "🔗", "noun", "m", "C'è un vincolo forte tra loro.", "There's a strong tie between them."],
      ["il sostegno", "support", "🤝", "noun", "m", "Conto sul sostegno della mia famiglia.", "I count on my family's support."],
      ["la separazione", "separation", "💔", "noun", "f", "La separazione è stata difficile.", "The separation was hard."],
      ["accogliere", "to take in", "🫂", "verb", "", "Hanno accolto un bambino rifugiato.", "They took in a refugee child."],
      ["il seno familiare", "the family fold", "👪", "phrase", "", "È cresciuto nel seno di una famiglia umile.", "He grew up in a humble family."],
      ["i parenti stretti", "close relations", "👥", "noun", "m", "Sono venuti solo i parenti stretti.", "Only close relations came."],
      ["consanguineo", "blood-related", "🧬", "adjective", "", "Non sono parenti consanguinei.", "They are not blood relatives."],
      ["la discendenza", "offspring", "🌳", "noun", "f", "Non hanno avuto discendenza.", "They had no offspring."],
      ["vegliare su", "to watch over", "🕯️", "phrase", "", "I genitori vegliano sui figli.", "Parents watch over their children."],
    ],
  },
];
